export const workflowReport = {
  workflow_report: "Informe De Flujo De Trabajo",
  workflow_name: "Nombre del flujo de trabajo",
  approvers: "Aprobadores",
  review_allowed: "Revisión permitida",
  disable_approval: "Deshabilitar aprobación",
  created_on: "Creado el",
  total_pending_approval_docs: "Total de documentos pendientes de aprobación",
  total_approved_docs: "Total de documentos aprobados",
  total_rejected_docs: "Total de documentos rechazados",
  total_workflow: "Total de flujos de trabajo",
  most_executed_workflows: "Flujos de trabajo más ejecutados",
  most_executed_workflow_approved_by:
    "Flujo de trabajo más ejecutado aprobado por",
  most_executed_workflow_rejected_by:
    "Flujo de trabajo más ejecutado rechazado por",
  most_executed_workflow: "Flujo de trabajo más ejecutado",
  most_executed_workflow_count:
    "Cantidad de ejecuciones del flujo de trabajo más ejecutado",
  approved_by: "Aprobado por",
  rejected_by: "Rechazado por",
  overview: "Resumen",
  approver_email: "Correo electrónico del aprobador",
  total_executions: "Total de ejecuciones",
  total_pending_approval: "Total pendiente de aprobación",
  total_approved: "Total aprobado",
  total_rejected: "Total rechazado",
  workflow_createdOn: "Flujo de trabajo creado el",
  last_updated: "Última actualización",
  most_workflow_approved_by: "Flujo de trabajo más aprobado por",
  most_workflow_rejected_by: "Flujo de trabajo más rechazado por",
  is_runtime: "Tiempo de ejecución",
  is_active: "Activo",
  is_review_document: "Revisión permitida",
  workflow_approval_status: "Estado de aprobación del flujo de trabajo",
  number_of_documents: "Número de documentos",
  no_data_available: "No hay datos disponibles",
  total: "Total",
  document_uploaded_in_portal: "Documento subido en el portal",
  document_integrated_into_output_data:
    "Documento integrado en los datos de salida",
  pending_integration: "Integración pendiente",
  processed_and_reviewed: "Procesado y revisado",
  documents_in_failed_status: "Documentos en estado fallido",
  documents_in_processed_and_reviewed_status:
    "Documentos en estado procesado y revisado",
  document_usage_report: "Informe De Uso De Documentos",
  document_in_need_review_status: "Documento en estado de revisión",
  document_count: "Conteo de documentos",
  "Manual view": "Vista manual",
  "Email view": "Vista de correo electrónico",
  "Sent to ERP": "Enviado a ERP",
  "Not sent to ERP": "No enviado a ERP",
  "Need review": "Necesita revisión",
  "Other documents": "Otros documentos",
  "Total documents": "Total de documentos",
  "Failed documents": "Documentos fallidos",
  "Pending integration": "Integración pendiente",
  "Processed and reviewed": "Procesado y revisado",
  "Workflow name": "Nombre del flujo de trabajo",
  "Start date is required": "Se requiere fecha de inicio",
  "End date is required": "Se requiere fecha de finalización",
  "End date cannot be before start date":
    "La fecha de finalización no puede ser anterior a la fecha de inicio",
  "Start date cannot be in the future":
    "La fecha de inicio no puede estar en el futuro",
  "End date cannot be in the future":
    "La fecha de finalización no puede estar en el futuro",
  User: "Usuario",
  "Customer ID": "ID de cliente",
  analytics: "Analítica",
  "Yearly Amount": "Cantidad anual",
  "Monthly Amount Trend": "Tendencia de cantidad mensual",
  "Paid vs Unpaid Invoices": "Facturas pagadas vs no pagadas",
  "Category Distribution": "Distribución por categoría",
  "Vendor Distribution": "Distribución de proveedores",
  "Document Type distribution": "Distribución por tipo de documento",
  "Vendor-Level Sankey Flow": "Flujo de Sankey a nivel de proveedor",

  TotalAmount: "Cantidad total",
  AccountPayable: "Cuentas por pagar",
  AccountReceivable: "Cuentas por cobrar",
  Invoice: "Factura",
  DeliveryNote: "Nota de entrega",
  PurchaseOrder: "Orden de compra",
  Expense: "Gasto",
  Stockable: "Almacenable",
  Investment: "Inversión",
  Inventory: "Inventario",
  Other: "Otro",
  yearly_amount: "Cantidad anual",
  Year: "Año",
  Month: "Mes",
  OverDue: "Vencido",
  "New Field": "Nuevo Campo",
  document_type_distribution: "Distribución por tipo de documento",
  monthly_amount_trend: "Tendencia de cantidad mensual",
  "UnSpecified Vendors": "Proveedores no especificados",
  failed_to_fetch_chart_data: "Error al obtener datos",
  monthly_document_summary: "Resumen mensual de documentos",
  Uploaded: "Subido",
  uploaded: "Subido",
  success_integrated: "Integrado con éxito",
  fail_integrated: "Integrado fallida",
  year_wise_document_summary: "Resumen anual de documentos",
  "Document Summary Table": "Tabla de resumen de documentos",
  "Document Summary": "Resumen de documentos",
  "Add Report": "Agregar informe",
  "Add a new custom report": "Agregar un nuevo informe personalizado",
  "Report name": "Nombre del informe",
  Cancel: "Cancelar",
  "Report name is required": "Se requiere nombre del informe",
  "Failed to add report": "Error al agregar informe",
  "Edit custom report": "Editar informe personalizado",
  "Save Report": "Guardar informe",
  workflow_approvers: `Aprobadores del flujo de trabajo`,
  workflow_approvers_with_value: `Aprobadores del flujo de trabajo: {{approverEmail}}`,
  workflow_approval_status_by_workflow_name: `Estado de aprobación por flujo de trabajo`,
  workflow_approval_status_by_approvers: `Estado de aprobación por aprobadores`,
  document_approval_summary_report:
    "Informe resumido de aprobación del documento",
  start_date: "Fecha de inicio",
  end_date: "Fecha de fin",
  download: "Descargar",
  start_date_required: "La fecha de inicio es obligatoria",
  end_date_required: "La fecha de fin es obligatoria",
  csv_downloaded_successfully: "CSV descargado correctamente",
  failed_to_download_csv: "Error al descargar el CSV",
};
